var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.percentMe >= 0)?_c('h5',[_vm._v("My data "),_c('ProgressBar',{attrs:{"percent":_vm.percentMe}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }